import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/core/services';
import { CopyrightComponent, TitleComponent } from '@app/shared/components';
import { RequiredNoWhitespaceDirective } from '@app/shared/directives/validators/required-no-whitespace.directive';

@Component({
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.less'],
	standalone: true,
	imports: [
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		RequiredNoWhitespaceDirective,
		NgIf,
		MatButtonModule,
		TitleComponent,
		CopyrightComponent,
	],
})
export class LoginComponent implements OnInit {
	readonly title = 'Welcome to Bookkeeping';
	unitId: string;
	returnUrl: string;

	constructor(
		private readonly route: ActivatedRoute,
		private readonly auth: AuthService,
	) {}

	ngOnInit(): void {
		this.unitId = this.auth.defaultUnitId;
		this.setReturnUrl();
		// TODO: Determine if we still need to get login errors from the auth service
	}

	setReturnUrl(): void {
		this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');

		// The Auth0 password reset URL includes an extra issuer value in the link that returns to the app, which
		// ends up being tacked onto the return URL parameter. If we don't strip off that value, the user will not
		// be redirected to the home page correctly.
		// Determine if we still need to do something like this.
		// const issuerPosition = this.returnUrl ? this.returnUrl.indexOf('?iss=') : -1;
		// if (issuerPosition >= 0) {
		// 	this.returnUrl = this.returnUrl.slice(0, issuerPosition);
		// }
	}

	onSubmit() {
		this.unitId = this.unitId.toUpperCase();
		// TODO: Determine how to handle returnUrl with OIDC login
		this.auth.login(this.unitId);
	}
}
